import { errorMessages } from "./ErrorMessages";
import { captureAppError } from "../../sentry";
export const handleApiError = async (error) => {
  captureAppError(error, {
    tags: {
      source: "handleApiError",
      statusCode: error?.response?.status,
      method: error?.config?.method,
    },
    extra: {
      url: error?.config?.url,
      responseData: error?.response?.data,
    },
  });

  if (error.message in errorMessages) {
    throw new Error(error.message);
  }
  if (!error.response) {
    throw new Error("Network error occurred during API call");
  }

  const statusCode = error.response.status;

  if (statusCode >= 500) {
    throw new Error(
      `API request failed with status code: ${statusCode} (Server Error)!`
    );
  } else if (statusCode >= 400) {
    if (
      error.response.data &&
      (error.response.data.detail === "No such user" ||
        error.response.data.detail === "the token is wrong")
    ) {
      localStorage.clear();
      sessionStorage.clear()

      throw new Error(
        "Either the token is wrong or has expired, Please login again!"
      );
    } else if (
      error.response.data &&
      error.response.data.detail ===
        "You do not have permission to perform this action."
    ) {
      throw new Error("unauthorizedAccess");
    } else if (
      error.response.data &&
      error.response.data.detail === "Email/Password is wrong!!"
    ) {
      throw new Error("invalidCredentials");
    } else if (statusCode == 404) {
      throw new Error("Network issues!! Please check your internet!");
    } else {
      throw new Error(
        `API request failed with status code: ${statusCode} (Client Error)!`
      );
    }
  }
  console.error("Unexpected error:", error);
  throw error;
};
